import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaHeart } from "react-icons/fa";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const MyWishlist = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState("");
  const token = localStorage.getItem("STITCHD_ID"); // Or however you manage user IDs

  useEffect(() => {
    if (token) {
      const decoded = jwtDecode(token);
      setUserId(decoded._id);
    }
  }, [token]);

  useEffect(() => {
    const fetchWishlistItems = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_URL}/user/${userId}/wishlist`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setItems(response.data.wishlist);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching wishlist items:", error);
        setLoading(false);
      }
    };

    if (userId) {
      fetchWishlistItems();
    }
  }, [userId]);

  const handleRemoveItem = async (productId) => {
    try {
      await axios.delete(
        `${process.env.REACT_APP_URL}/user/wishlist/${userId}/${productId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setItems((prevItems) =>
        prevItems.filter((item) => item._id !== productId)
      );
    } catch (error) {
      console.log("Error removing item:", error);
    }
  };

  return (
    <div className="md:ml-20 md:mt-28 mt-20 mb-10">
      <div className="flex justify-between font-sans font-semibold text-2xl mb-4 mx-2 text-red-600">
        <p>My Wishlist</p>
        <FaHeart className="mt-1 mr-1" />
      </div>
      <div className="container mx-auto grid grid-cols-2 md:grid-cols-3 gap-1 md:gap-8 mb-4">
        {loading ? (
          [...Array(6)].map((_, index) => (
            <div key={index} className="p-4">
              <Skeleton height={200} />
              <Skeleton count={2} />
            </div>
          ))
        ) : items.length === 0 ? (
          <p className="col-span-2 md:col-span-3 text-center text-gray-500 text-3xl md:text-5xl p-2 font-twentieth-century">
            There are no items in your wishlist!
          </p>
        ) : (
          items.map((item) => (
            <div
              className="transform transition duration-300 md:hover:scale-105 hover:shadow-lg"
              key={item._id}
            >
              <Link
                to={`/product/${item._id}`}
                className="bg-gray-100 overflow-hidden md:rounded-md"
              >
                <img
                  src={`${process.env.REACT_APP_URL}/${item.images[0]}`}
                  alt={item.name}
                  className="w-full h-auto object-cover"
                />
                <div className="p-4">
                  <h3 className="text-md font-twentieth-century font-medium text-gray-800 truncate">
                    {item.name}
                  </h3>
                  <h3 className="text-md font-twentieth-century font-medium text-gray-800">
                    {item.price}
                  </h3>
                </div>
              </Link>
              <div className="h-px w-auto bg-gray-400"></div>
              <div className="flex justify-between font-twentieth-century m-2">
                <button
                  className="text-gray-400 hover:text-gray-600"
                  onClick={() => handleRemoveItem(item._id)}
                >
                  REMOVE
                </button>
                <Link
                  to={`/product/${item._id}`}
                  className="text-red-500 hover:text-red-700"
                >
                  MOVE TO BAG
                </Link>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default MyWishlist;
